// Cloth, leather and paint textures for people and the rider.
import { rnd } from '../lib/random.js';
import { canvasTex } from '../lib/factory.js';

// ---- cloth, leather and paint textures for people and the rider ----
export const noiseFill = (c, w, h, n, cols, size = 1.5) => {
  for (let k = 0; k < n; k++) {
    c.fillStyle = cols[Math.floor(rnd() * cols.length)];
    c.fillRect(rnd() * w, rnd() * h, size, size);
  }
};
export const jacketTex = canvasTex(256, 256, (c) => {
  c.fillStyle = '#4c5642';
  c.fillRect(0, 0, 256, 256);
  noiseFill(c, 256, 256, 9000, ['#535e48', '#454e3c', '#58634c', '#3f4737'], 1.2);
  c.strokeStyle = 'rgba(25,28,22,.55)';
  c.lineWidth = 2;
  for (let y = 24; y < 256; y += 36) {
    c.beginPath();
    c.moveTo(0, y);
    c.lineTo(256, y);
    c.stroke();
  }
  c.setLineDash([3, 3]);
  c.strokeStyle = 'rgba(200,205,180,.35)';
  c.lineWidth = 1;
  for (let y = 28; y < 256; y += 36) {
    c.beginPath();
    c.moveTo(0, y);
    c.lineTo(256, y);
    c.stroke();
  }
  c.setLineDash([]);
  c.fillStyle = '#c9ccc2';
  c.fillRect(0, 118, 256, 7);
  c.fillStyle = 'rgba(255,255,255,.4)';
  c.fillRect(0, 119, 256, 2);
  c.fillStyle = 'rgba(20,22,18,.6)';
  c.fillRect(0, 0, 256, 6);
  c.fillRect(0, 250, 256, 6);
});
export const denimTex = canvasTex(128, 128, (c) => {
  c.fillStyle = '#34445f';
  c.fillRect(0, 0, 128, 128);
  for (let i = -128; i < 128; i += 3) {
    c.strokeStyle = rnd() < 0.5 ? 'rgba(80,100,135,.5)' : 'rgba(25,32,48,.5)';
    c.lineWidth = 1;
    c.beginPath();
    c.moveTo(i, 0);
    c.lineTo(i + 128, 128);
    c.stroke();
  }
  noiseFill(c, 128, 128, 1500, ['rgba(160,175,200,.25)', 'rgba(20,25,40,.3)'], 1);
});
denimTex.repeat.set(2, 2);
export const leatherTex = canvasTex(64, 64, (c) => {
  c.fillStyle = '#1e1e20';
  c.fillRect(0, 0, 64, 64);
  noiseFill(c, 64, 64, 1400, ['#2a2a2d', '#151517', '#333336'], 1);
  c.strokeStyle = 'rgba(70,70,75,.5)';
  for (let k = 0; k < 6; k++) {
    c.beginPath();
    c.moveTo(rnd() * 64, rnd() * 64);
    c.lineTo(rnd() * 64, rnd() * 64);
    c.stroke();
  }
});
export const seatTex = canvasTex(128, 128, (c) => {
  c.fillStyle = '#1c1c1f';
  c.fillRect(0, 0, 128, 128);
  noiseFill(c, 128, 128, 2500, ['#242428', '#141416'], 1);
  c.strokeStyle = 'rgba(120,120,128,.55)';
  c.setLineDash([2, 2]);
  for (let i = -128; i < 256; i += 16) {
    c.beginPath();
    c.moveTo(i, 0);
    c.lineTo(i + 128, 128);
    c.moveTo(i, 128);
    c.lineTo(i + 128, 0);
    c.stroke();
  }
  c.setLineDash([]);
});
seatTex.repeat.set(2, 2);
export const nylonTex = canvasTex(64, 64, (c) => {
  c.fillStyle = '#272a2f';
  c.fillRect(0, 0, 64, 64);
  c.strokeStyle = 'rgba(70,75,82,.6)';
  c.lineWidth = 0.7;
  for (let i = 0; i < 64; i += 4) {
    c.beginPath();
    c.moveTo(i, 0);
    c.lineTo(i, 64);
    c.moveTo(0, i);
    c.lineTo(64, i);
    c.stroke();
  }
  c.fillStyle = '#111';
  c.fillRect(0, 30, 64, 3);
  c.fillStyle = '#9aa0a6';
  c.fillRect(44, 28, 4, 7);
});
export const helmetTex = canvasTex(256, 128, (c) => {
  c.fillStyle = '#141416';
  c.fillRect(0, 0, 256, 128);
  c.fillStyle = '#d9412c';
  c.fillRect(0, 34, 256, 10);
  c.fillStyle = '#f2f0ea';
  c.fillRect(0, 46, 256, 4);
  c.fillStyle = '#2d6fd6';
  c.fillRect(0, 52, 256, 3);
  c.fillStyle = 'rgba(255,255,255,.08)';
  for (let x = 0; x < 256; x += 32) c.fillRect(x, 8, 10, 3);
});
export const treadTex = canvasTex(256, 32, (c) => {
  c.fillStyle = '#1b1b1c';
  c.fillRect(0, 0, 256, 32);
  c.fillStyle = '#0c0c0d';
  for (let x = 0; x < 256; x += 8) {
    c.fillRect(x, 6, 3, 9);
    c.fillRect(x + 4, 17, 3, 9);
  }
  c.fillRect(0, 15, 256, 2);
});
treadTex.repeat.set(4, 1);
